<template>
  <section class="section container pt-0">
    <sales-datatable :module_settings="module_settings" />
  </section>
</template>

<script>
import { get_configuration, error_message } from "@/utils";
import SalesDatatable from "./sales_datatable/Index.vue";

export default {
  name: "SaleIndex",
  components: { SalesDatatable },
  data() {
    return {
      module_settings: {},
    };
  },
  methods: {},
  mounted() {},
  created() {
    let v = this;
    get_configuration(this)
      .then((conf) => {
        v.module_settings = conf;
      })
      .catch((error) => {
        error_message(error);
      });
  },
};
</script>

<style scoped></style>
